import { I18NextPipe } from 'angular-i18next';
import { StorageType } from 'mbs-ui-shared@models';

export enum CreationMode {
  Create,
  Edit
}

export const helpLinkMap = {
  [StorageType.Azure]: '/billing-storage/storage-providers/azure/sign-up-for-microsoft-azure',
  [StorageType.AzureVM]: '/billing-storage/storage-providers/azure/sign-up-for-microsoft-azure',
  [StorageType.BackblazeB2]: '/billing-storage/storage-providers/b2/sign-up-for-backblaze-b2',
  [StorageType.Google]: '/billing-storage/storage-providers/google-cloud/sign-up-for-google-cloud',
  [StorageType.GoogleCloud]: '/billing-storage/storage-providers/google-cloud/sign-up-for-google-cloud',
  [StorageType.AmazonS3]: '/billing-storage/storage-providers/amazon/sign-up-amazon-s3',
  [StorageType.AmazonS3Chinese]: '/billing-storage/storage-providers/amazon/sign-up-amazon-s3'
};

export const e2eLocators = {
  main: 'add-storage-accounts-wizard',
  selectStorageTab: 'select-storage-tab',
  inputCredentialsTab: 'input-credentials-tab',
  setDestinationTab: 'set-destination-tab',
  amazonAdvancedSettingsTab: 'amazon-advanced-settings-tab',
  summaryTab: 'summary-tab',
  nextBtn: 'next-btn',
  backBtn: 'back-btn',
  saveBtn: 'save-btn',
  storageBtn: 'storage-btn',
  howToSignUp: 'how-to-sign-up',
  storageDisplayName: 'storage-display-name-ctrl'
};

export enum CheckerError {
  NotCompatible = 4505,
  Timeout = 4506,
  Unknown = 4507
}

export const getErrorMap = (i18N: I18NextPipe) => ({
  [CheckerError.NotCompatible]: i18N.transform('storages:addStorageAccountWizard.error.notCompatible'),
  [CheckerError.Timeout]: i18N.transform('storages:addStorageAccountWizard.error.timeout'),
  [CheckerError.Unknown]: i18N.transform('storages:addStorageAccountWizard.error.unknown')
});
